import { render, staticRenderFns } from "./dot.vue?vue&type=template&id=e4517f3e&scoped=true&"
import script from "./dot.vue?vue&type=script&lang=js&"
export * from "./dot.vue?vue&type=script&lang=js&"
import style0 from "./dot.vue?vue&type=style&index=0&id=e4517f3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4517f3e",
  null
  
)

export default component.exports